import styled from "@emotion/styled";

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;

  max-width: 1380px;

  padding: 40px 18px 33px;
  border-radius: ${({ theme }) => theme.radii.normal};
  background-color: ${({ theme }) => theme.colors.black};
  margin-bottom: 25px;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    padding: 79px 72px 189px;
    border-radius: ${({ theme }) => theme.radii.big};
    margin-bottom: 165px;
  }
`;

const Title = styled.h1`
  margin-bottom: 20px;

  font-size: 32px;
  font-weight: ${({ theme }) => theme.fontWeight.semiBold};
  line-height: 105%;
  text-align: center;
  color: ${({ theme }) => theme.colors.white};

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    font-size: 88px;
    margin-bottom: 32px;
  }
`;

const Text = styled.div`
  position: relative;
  margin-bottom: 187px;

  font-size: 14px;
  line-height: 150%;
  text-align: center;
  color: ${({ theme }) => theme.colors.secondary.minor};

  z-index: 1;

  transition: color 0.3s ease-in-out;

  p {
    a {
      color: ${({ theme }) => theme.colors.secondary.minor};
      transition: color 0.3s ease-in-out;

      &:hover {
        color: ${p => p.theme.colors.hover.background};
      }
    }
  }

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    max-width: 847px;

    font-size: ${p => p.theme.fontSizes.m};
    line-height: 160%;
    margin-bottom: 0;
  }
`;

const ContainerFilter = styled.div`
  padding: 0 24px;
  bottom: -140px;
  width: 100%;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    position: absolute;
    transform: translateX(-50%);
    left: 50%;
    width: 93%;
  }
`;

export { Wrapper, Title, Text, ContainerFilter };
